// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-h_gu","catalogByServiceItem__title":"c-h_gv"};